import { useQuery } from 'react-query';
import { CustomAxios } from 'redux/axios';

export type RoleAcl = {
  name: string;
  value: number;
};

export type Role = {
  roleId: string;
  name: string;
  description: string;
  type: string;
  enabled: boolean;
  public: boolean;
  acls: RoleAcl[];
  category: string;
  roleUuid: string;
  header: string;
};

type GetRolesResponse = {
  roles: Role[];
};

const getRoles = (): Promise<Role[]> => {
  return CustomAxios.get<GetRolesResponse>('/auth-api/v3/roles').then(
    (res) => res.data?.roles ?? []
  );
};

export const useGetRoles = () => {
  return useQuery(['roles-permissions'], getRoles, {
    staleTime: 5 * 60 * 1000,
  });
};
